import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {BehaviorSubject } from 'rxjs';
import { SharedConsts } from '../constants';
import { Router } from '@angular/router';
import {publicIpv4} from 'public-ip';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  apiurl = environment.apiURL
  apiRequestCount = new BehaviorSubject(0);
  getApiRequestCount = this.apiRequestCount.asObservable();

  constructor(
    private http :HttpClient, 
    private router: Router) { }


  public getIPAddress() {
    return this.http.get("https://jsonip.com");
  }
  async  setIpAddress() {
    let ips = SharedConsts.HOST_ALLOWED
    let newip = await publicIpv4();
    if ((ips.includes(String(newip)))){
        return true
    }
    else{
        this.router.navigate(['/maintenance']);
        return false;
    }
  
  }
  updateStoreSortValue(obj:any) :void {
    this.apiRequestCount.next(obj)
  }


  getCategories() {
    return this.http.post<any>(`${this.apiurl}rest/V1/footerCategories`, {});
  }

  getCmspage(){
    return this.http.post<any>(`${this.apiurl}rest/V1/getCmspage`, {});
  }

  getminiCart(){
    return this.http.post<any>(`${this.apiurl}rest/V1/miniCart`, {});
  }

  quickAdd(obj){
    return this.http.post<any>(`${this.apiurl}rest/V1/quickAdd`, obj);
  }
  topMenu(){
    return this.http.post<any>(`${this.apiurl}rest/V1/topMenu`, {});
  }

  getGlobalValues(){
    return this.http.post<any>(`${this.apiurl}rest/V1/getGlobalParameters`, {});
  }

  //-=--------------------helper methods-----------------------------


  redirectAsBrandSelected(brandId:number,isScreenProductCatalogue:boolean,activateRoute:any,categoryId?:string):void{
    const  url  = activateRoute;
    if(isScreenProductCatalogue && url.params?.['_value']?.categoryid && !categoryId){

      this.router.navigate(['/product/listing/',url.params?.['_value']?.categoryid],{ queryParams: { brandId} })
    
    }else if(isScreenProductCatalogue && categoryId){
      
       this.router.navigate(['/product/listing/',categoryId],{ queryParams: { brandId} })
    }else{
      this.router.navigate(['/product/listing/All'],{ queryParams: { brandId} })
    }
  }

  public getStoreVatFreeMargin(margin_obj:any){
    let unit_price, finalMargin;
    if (margin_obj){
      if ( 'special_price' in margin_obj){
        unit_price =    margin_obj.special_price / margin_obj.unit_pack;
      }
      else{
        unit_price = margin_obj.price / margin_obj.unit_pack;
      }
      let Taxrate = 0 + 100;
      let MarginRsp = (margin_obj.rsp / Taxrate) * 100;
      let MarginPrice = MarginRsp - unit_price;
      finalMargin = (MarginPrice/MarginRsp) * 100;

      return finalMargin.toFixed(2)

    }
    
  }

}
